import { Injectable } from "@angular/core";
import { IVwapService, Vwap } from "../IVwapService";
import { PairVwap } from "../../model/core/PairVwap";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

export abstract class VwapPromiseService implements IVwapService {
  abstract getVwapForOrders(orderIds: Array<string>, ndfMode: boolean): Promise<Vwap>;

  abstract getVwapForTradeDeals(tradeDealIds: string[]): Promise<Vwap>;

  abstract getVwapForSelectedDeals(deals: CubiqTS.DealImpl[]): Promise<Vwap>;
}
